import React, { useState } from 'react'
import Button from '../../../Forms/Button'
import Modal from '../../../Modal'
import { apiClient } from '../../../../helpers/api'
import { useStore } from '../../../../store'
import { upsertFloorPlanImage } from '../../../../services/floorplans'
import { capitalize } from '../../../../helpers/string'
import { getPackageName } from '../../../../helpers/packages'
import use3DViewer from '../../../../hooks/use3DViewer'
import use3DViewerEvent from '../../../../hooks/use3DViewerEvent'

function dataUriToBlob(dataUri) {
  const byteString = atob(dataUri.split(',')[1])
  const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0]

  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uintArray = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i)
  }

  return new Blob([arrayBuffer], { type: mimeString })
}

function DebugControls({ className = '' }) {
  const [screenshotUrl, setScreenshotUrl] = useState(null)
  const { data } = useStore()

  async function uploadImage(imageDataUri) {
    // Prepare the form data
    const formData = new FormData()

    const blob = dataUriToBlob(imageDataUri)
    const imageName = `${data.selectedLine.name}_floorplan_autoupload.png`
    const path = `production/real_estate_companies/${capitalize(
      data.property.real_estate_company.company_name,
    )}/properties/${capitalize(data.property.property_name)}/${capitalize(
      data.selectedLine.name,
    )}/package/${capitalize(
      getPackageName(data.selectedPackage),
    )}/floor_plans`.replaceAll(' ', '_')

    formData.append('file', blob, imageName) // Data URI directly added here
    formData.append('filePath', path)
    formData.append('bucket', 'sparx-cdn')

    try {
      await apiClient.post('/api/resource', formData)
      await upsertFloorPlanImage({
        id: data.selectedPackage.unit_plans.find((p) => p.unit_type_level.id === data.selectedLevel.id).id,
        src: `${path}/${imageName}`,
        unit_type_id: data.selectedLine.id,
        unit_type_level_id: data.selectedLevel.id,
        vendor_id: data.selectedPackage.vendor.id,
        package_id: data.selectedPackage.id,
        design_layout_id: data.selectedLevel.design_layouts.find((l) => l.package.id === data.selectedPackage.id).id,
      })
    } catch (error) {
      console.error('Error uploading image:', error.response?.data || error.message)
    }
  }



  const { send } = use3DViewer(null, '3d-viewer')
  


  use3DViewerEvent('screenshot-ready', async (data) => {
     await uploadImage(data.payload.url)
     setScreenshotUrl(data.payload.url)
   })


  const actions = [
    // Temporary disabled, will be fixed in future
    // {
    //   label: 'Capture top image',
    //   action: () => {
    //     window.captureModelScreenshot((url) => {
    //       setScreenshotUrl(url)
    //     }, 'top')
    //   },
    // },
    {
      label: 'Capture image',
      action: () => {
        send('screenshot')
      },
    },
  ]

  return (
    <>
      {screenshotUrl && (
        <Modal>
          <div className="text-center">Uploaded successfuly</div>
          <img src={screenshotUrl} />
          <div>
            <Button className="bg-black w-full" onClick={() => setScreenshotUrl(null)}>
              Close
            </Button>
          </div>
        </Modal>
      )}
      <div className={`${className} bg-[#ff7b00] p-4 rounded-r-lg flex flex-col`}>
        <div className="mb-1 font-bold ">Debug controls</div>
        {actions.map((a) => (
          <Button className="bg-black mt-3 first:mt-0" onClick={a.action}>
            {a.label}
          </Button>
        ))}
      </div>
    </>
  )
}

export default DebugControls
